module.exports = __webpack_public_path__ + "static/media/CK.5389188d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CK.svg
// module id = 2129
// module chunks = 7